const constants = {
  ADD_TO_BAG: 'Add To Bag',
  ADOBE_COOKIE_NAME: 'AMCV_8D0867C25245AE650A490D4C@AdobeOrg',
  ANALYTICS: {
    RVI: 'rvi',
    PROS: 'pros',
    FBT: 'frequently bought together',
    CONTENT_VIEW: 'content view',
  },
  ASSETS: {
    MACYS: '//assets.macys.com',
    BLOOMINGDALES: '//assets.bloomingdales.com',
  },
  BCOM_ONLINE_UID: 'bloomingdales_online_uid',
  BREAK_POINTS: {
    SMALL: 600,
    MEDIUM: 1024,
    LARGE: 1440,
  },
  BREAK_POINT_TYPE: {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
  },
  CAROUSEL_ITEM_TOTAL_PADDING: {
    LARGE: 20,
  },
  CAROUSEL_SWATCHES_BUTTON_WIDTH: 25,
  CAROUSEL_TYPE: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
    COLORSWATCHES: 'colorswatches',
  },
  CAT_SPLASH_PAGE: {
    C2FLEX_ZONE_A: 'C2FLEX_ZONE_A',
  },
  CLASS_SELECTOR: '.prosPanel',
  CLASS_SELECTOR_CLASS: 'prosPanel',
  COMPARISON_ATTRIBUTE_NAME: 'key',
  COMPARISON_CATEGORY_ID: 'attrId',
  COMPARISON_PAGE_SIZE: 15,
  COMPARISON_TABLE_HEADER_TEXT: 'Compare with similar items',
  COOKIES: {
    THIRTHY_DAYS_IN_MS: 2592000000,
    ONE_DAY_IN_MS: 86400000,
    MACHINE_ID: 'macys_online',
    USER_ID: 'macys_online_uid',
    BAG_GUID: 'macys_bagguid',
    BCOM_BAG_GUID: 'bloomingdales_bagguid',
    DCA: 'dca',
    BAGWRAPPERID: 'bagWrapperId',
    CUSTOMER_GUID: 'macys_online_guid',
    BCOM_CUSTOMER_GUID: 'bloomingdales_online_guid',
  },
  CURRENCY_CODE: 'currency',
  CUSTOMER_SHIP_LOCATION: 'CSL',
  DEFAULT_FCC_CATEGORY_ID: 118,
  DEFAULT_HEADER_TEXT: 'you might also like...',
  DEVICE: {
    DESKTOP: 'DESKTOP',
    PHONE: 'PHONE',
  },
  ENTRY_POINT: {
    MCOM: 'mcom',
    BCOM: 'bcom',
  },
  FCC_SORT_ORDER: {
    FEATURED_ITEMS: 'ORIGINAL',
    BEST_SELLERS: 'BEST_SELLERS',
    CUSTOMER_TOP_RATED: 'CUSTOMER_RATING',
    NEW_ARRIVALS: 'NEWNESS',
    PRICE_ASCENDING: 'PRICE_ASCENDING',
    PRICE_DESCENDING: 'PRICE_DESCENDING',
  },
  HEADER_SEPARATOR: '@',
  HEARTING_MSGS: {
    ADDED_TO_LIST: 'Added To List',
    REMOVED_FROM_LIST: 'Removed From List',
    UNABLE_TO_ADD: 'Unable To Add',
    UNABLE_TO_REMOVE: 'Unable To Remove',
  },
  ID_SELECTOR: '#prosPanel',
  LINK_NAME: {
    EDIT: 'Edit',
  },
  MAX_HEADER_LENGTH: 50,
  MCMID: 'MCMID',
  MCOM_ONLINE_UID: 'macys_online_uid',
  MCOM_EXPERIMENTAL_NUMBER_OF_ITEMS: 6,
  MIN_ITEMS_AMOUNT_FOR_DASHBOARD_RVI: 2,
  MISCGCS: 'MISCGCs',
  MULTITAB_SELECTOR: '.pros-horizontal-multi-tab',
  ORIENTATION: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
  },
  PAGE: {
    HOME_PAGE: 'HOME_PAGE',
    SEARCH_PAGE: 'SEARCH_PAGE',
    BROWSE_PAGE: 'BROWSE_PAGE',
    CAT_SPLASH_PAGE: 'CAT_SPLASH_PAGE',
    PURCHASE_HISTORY_PAGE: 'PURCHASE_HISTORY_PAGE',
    PURCHASE_DETAIL_PAGE: 'PURCHASE_DETAIL_PAGE',
    RESPONSIVE_BAG: 'RESPONSIVE_BAG',
  },
  PATH_FCC_RECOMMENDATIONS:
    '/api/catalog/v2/categories/CATEGORY_ID/products?_fields=navigationPoolProducts&returnNavigationProductPool=true&returnFacets=false&returnFeaturedProductPool=false&_limit=15&_offset=1',
  PATH_CATEGORY_FALLBACK_RECOMMENDATIONS:
    '/xapi/discover/v1/page?pathname=PATH_NAME&id=CATEGORY_ID&facetsOnly=true&productsPerPage=15&sortBy=ORIGINAL',
  PATH_RTO_RECOMMENDATIONS: '/sdp/rto/request/recommendations',
  PROS_UPPERCASE: 'PROS',
  RCS_KEY: 'richRelevanceRCS',
  RECENTLY_VIEWED_ITEMS: 'recentlyViewedItems',
  RECENTLY_VIEWED_ITEMS_MAX_LIMIT: {
    bcom: 12,
    mcom: 15,
  },
  RESPONSIVE_PROS_WIDTH: {
    SMALL: 180,
    MEDIUM: 228,
    LARGE: 230,
  },
  RTD_COOKIE_NAME: 'RTD',
  SB_ZONES: {
    SB_ZONE_A: 'SB_ZONE_A',
    SB_ZONE_B: 'SB_ZONE_B',
    SB_ZONE_C: 'SB_ZONE_C',
  },
  HNF_ZONE: 'HNF',
  SHIPPING_COUNTRY_COOKIE_NAME: 'shippingCountry',
  SHIP_IT: 'ship it',
  SHOW_CAROUSEL_BREAKPOINT: 5,
  SIZE_CASES: {
    NO_SIZE: 'no size',
    ONE_SIZE: 'one size',
  },
  SKELETON_LOADING_TIMEOUT: 1000,
  STATE_COOKIE_NAME: 'USERST',
  THUMBNAIL_SELECTOR: '.productThumbnail',
  UPC_BOPS_PURCHASABLE: 'UPC_BOPS_PURCHASABLE',
  VIEW_TYPE: {
    PROS: 'pros',
    RVI: 'rvi',
    POOL: 'pool',
    DASHBOARD: 'dashboard',
  },
  ZIP_CODE_COOKIE_NAME: 'USERPC',
};

export default constants;
